import type { TaskTimelineEntry } from '@erp/rpc';
import {
  AlarmIcon,
  ArrowRightIcon,
  BrainIcon,
  CursorClickIcon,
  FlagCheckeredIcon,
  HandTapIcon,
  PlusCircleIcon,
  RobotIcon,
  TrashIcon,
  TreeStructureIcon,
  UserSwitchIcon,
} from '@phosphor-icons/react';
export const TIMELINE_KIND_ICONS: Record<
  TaskTimelineEntry['kind'],
  React.ComponentType<{ className?: string; weight?: 'fill' | 'bold' }>
> = {
  task_created: PlusCircleIcon,
  task_status_changed: ArrowRightIcon,
  task_assignee_changed: UserSwitchIcon,
  task_concluded: FlagCheckeredIcon,
  task_deleted: TrashIcon,
  human_action: HandTapIcon,
  workflow_step_run: TreeStructureIcon,
  agent_run: RobotIcon,
  ai_reasoning: BrainIcon,
  task_snooze: AlarmIcon,
  operator_step: CursorClickIcon,
};
